<template>
    <v-ons-page>
      <v-ons-toolbar>
        <div v-if="back" class="left zindex9">
          <v-ons-back-button material></v-ons-back-button>
        </div>
        <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
          <slot> {{ item.title }}</slot>
        </div>
      </v-ons-toolbar>
        <audio id="audio">
            <source :src="item.path_audio" type="audio/mpeg"/>
            Your does not support the audio element.
        </audio>
        <div class="fullImage centerAll">
            <div v-for="(item,index) in item.imagesAudio">
                <img class="art" v-if="false" :src="require('../assets/img/art/'+item.img)"/>
            </div>
            <div>
                <img class="art" :src="require('../assets/img/art/'+image)"/>
            </div>
        </div>
        <v-ons-bottom-toolbar class="white">
            <div id="container">
                <div id="left" @click="behind()"><img height="17px" :src="backImage"/></div>
                <div class="center" v-if="!paused" @click="pause()">
                    <img height="17px" :src="pauseImage"/>

                </div>
                <div class="center" v-if="paused" @click="play()">
                    <img height="17px" :src="playImage"/>
                </div>
                <div id="right" @click="forward()"><img height="17px" :src="nextImage"/></div>
            </div>
        </v-ons-bottom-toolbar>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'

    export default {
        name: 'audio',
        computed: {
            image() {

                const intvalue = Math.trunc(this.currentPosition);



                console.log('Search new image fro second :' + intvalue);
                if (this.item.imagesAudio) {


                    this.item.imagesAudio.forEach((elementItem) => {
                        if(intvalue>=elementItem.second){

                            this.item.img = elementItem.img;
                        }
                    });

                    console.log('IMAGES');
                }
                console.log('Search new image:' + this.item.img);
                return this.item.img;

            }

        },
        data: function () {
            return {
                audioImage: null,
                backImage: require('../assets/img/UI/back.png'),
                nextImage: require('../assets/img/UI/next_audio.png'),
                pauseImage: require('../assets/img/UI/pause.png'),
                playImage: require('../assets/img/UI/play.png'),
                audio: this.item.path_audio,
                paused: null,
                media: null,
                //isIOs: navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i),
                isIOs: false,
                mediaTimer: null,
                currentPosition: 0
            }
        },
        methods: {
            pause() {
                if (this.isIOs) {
                    clearInterval(this.mediaTimer);
                    this.media.pause();
                } else {
                    this.audio.pause();
                }
                this.paused = true
            },
            play() {
                if (this.isIOs) {
                    this.media.play({playAudioWhenScreenIsLocked: true});
                    this.createInterval(this.media);
                } else {
                    this.audio.play();
                }
                this.paused = false
            },
            createInterval(myMedia) {
                this.mediaTimer = setInterval(() => {
                    // get media position
                    myMedia.getCurrentPosition(
                        // success callback
                        (position) => {
                            this.currentPosition = position;
                            if (position === -1) {
                                this.media.pause();
                                this.$emit('pop');
                            }


                            console.log(this.currentPosition);
                        }
                    );
                }, 1000);
            },
            forward() {
                if (this.isIOs) {
                    this.media.seekTo((this.currentPosition * 1000) + 10000);

                    // this.createInterval(this.media);
                } else {
                    this.audio.currentTime += 10;
                }
            },
            behind() {
                if (this.isIOs) {
                    this.media.seekTo((this.currentPosition * 1000) - 10000);
                    // this.media.play({playAudioWhenScreenIsLocked: true});
                    // this.createInterval(this.media);
                } else {
                    this.audio.currentTime -= 10;
                }
            },
            next() {
                let menuelements = this.$t("message.menuItems");
                let index = menuelements.indexOf(this.item);
                this.destroyed();
                if (index >= 0 && index < menuelements.length - 1) {
                    this.item = menuelements[index + 1];

                    if (this.item.img === "") {
                        this.item = menuelements[index + 2];
                    }
                } else {
                    this.item = menuelements[0];
                }
                this.mounted();
            },
            back() {
                let menuelements = this.$t("message.menuItems");
                let index = menuelements.indexOf(this.item);
                this.destroyed();
                if (index <= 0) {
                    this.item = menuelements[menuelements.length - 1];
                } else {
                    this.item = menuelements[index - 1];
                    if (this.item.img === "") {
                        this.item = menuelements[index - 2];
                    }
                }
                this.mounted();

            },
            mounted() {

                console.log(navigator.userAgent);
                if (this.isIOs) {
                    let myMedia = new Media(this.item.path_audio.substring(5, this.item.path_audio.length));
                    myMedia.play({playAudioWhenScreenIsLocked: true});
                    this.media = myMedia;
                    this.createInterval(myMedia);
                } else {
                    this.audio = document.getElementById('audio');
                    this.audio.src = this.item.path_audio;
                    //this.audio.play();
                    //this.paused = false;
                    this.paused = true;
                    this.audio.onended = () => {
                        this.$emit('pop');
                    };
                    this.audio.addEventListener('timeupdate', (event) => {

                        this.currentPosition = Math.floor(this.audio.currentTime);


                    }, false);

                }
                console.log(this.item.path_audio);
            },
            destroyed() {
                if (this.isIOs) {
                    this.media.pause();
                    this.media = null;
                    clearInterval(this.mediaTimer);
                    this.mediaTimer = null;
                    this.audio = null;
                } else {
                    this.audio = null;
                }
            }
        },
        props: [
            'item'
        ],
        components: {
            TopBar
        },
        mounted() {
            this.mounted();
        },
        destroyed() {
            this.destroyed();

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .white {
        background:#d9b100;
        height: 9.05%;
    }

    #container {
        display: flex;
        width: 100%;
        height: 100%;

    }

    #left {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 10%;
    }

    #right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 10%;
    }

    .center {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fullImage {
        width: 100%;
        height: 100%;
        /*display: flex;*/
    }

    .art {
        /*top: 50px;
        width: 100%;*/

        width: inherit;
        max-width: 100%;
        max-height: 100%;
        display: block;

        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .centerAll {
        display: flex;
        align-items: center;
        justify-content: center;
    }



</style>



// WEBPACK FOOTER //
// src/pages/AudioPage.vue